import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/what-we-do/WhatWeDoPage.js");
